/**
 * @fileoverview Zod schema for the forgot-password form.
 * @description Runs before the password-reset request is sent so obviously-invalid input never
 * reaches the API layer. Only checks presence/shape — whether the email is actually registered is
 * never revealed by this check or the request itself, to avoid leaking account existence. Every
 * issue message is a translation key (per this repo's i18n rule for validators), translated only
 * at the display call site in ForgotPasswordForm.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { z } from 'zod'

import { emailField } from '@/shared/lib/validation/contact-fields.schema'

export const forgotPasswordFormSchema = z.object({
  email: emailField({
    required: 'forgotPassword.errors.emailRequired',
    invalid: 'forgotPassword.errors.emailInvalid',
  }),
})

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordFormSchema>
